import { makeAutoObservable } from 'mobx';
import { UserModel } from '../models/user';
import { ScreenRecording } from '../interfaces/app';
import { UniversalSearchData } from '../interfaces/comment';
import { COLOR_THEME, COLOR_THEME_TYPE } from '../../global/constants';

interface Logo {
  url?: string;
}
interface CustomBrandingData {
  metaTitle?: string | undefined;
  logo?: Logo;
  primaryColor?: string;
  primaryDarkColor?: string;
}

export class AppStore {
  extractedDesktopView: number = 0;
  isPageScrolled: boolean = false;
  screenRecordingLoading: boolean = false;
  screenRecordingUrl: string = '';
  isNavbarShow: boolean = true;
  isAppLoading: boolean = false;
  customBranding: CustomBrandingData = {};
  userModalDetail: UserModel | null = null;
  isBubbleMenuOpen: boolean = false;
  snapList: ScreenRecording[] = [];
  universalSearchData: UniversalSearchData | null = null;
  authLoading: boolean = false;
  isPlanUpgradeModelOpen: boolean = false;
  isTabBarLoad: boolean = false;
  themeType: number = COLOR_THEME.LIGHT;
  themeMode: { theme: string } = { theme: COLOR_THEME_TYPE.LIGHT };

  constructor() {
    makeAutoObservable(this);
  }

  // Action to update themeType
  setThemeType(themeType: number) {
    // <-- Add this action
    this.themeType = themeType;
  }

  setThemeMode(theme: string) {
    this.themeMode.theme = theme;
  }

  //Updates the extracted desktop view value
  setExtractedDesktopView(extractedDesktopView: number) {
    this.extractedDesktopView = extractedDesktopView;
  }

  // Updates the page scroll state
  setIsPageScrolled(isPageScrolled: boolean) {
    this.isPageScrolled = isPageScrolled;
  }

  setScreenRecordingLoading(screenRecordingLoading: boolean) {
    this.screenRecordingLoading = screenRecordingLoading;
  }

  setScreenRecordingUrl(screenRecordingUrl: string) {
    this.screenRecordingUrl = screenRecordingUrl;
  }

  //set is navbar show
  setIsNavbarShow(isNavbarShow: boolean) {
    this.isNavbarShow = isNavbarShow;
  }

  // Updates the application loading state
  setIsAppLoading(isAppLoading: boolean) {
    this.isAppLoading = isAppLoading;
  }

  //set custom branding
  setCustomBranding(customBranding: CustomBrandingData) {
    this.customBranding = customBranding;
  }

  //set user modal detail
  setUserModalDetail(userModalDetail: UserModel) {
    this.userModalDetail = userModalDetail;
  }

  setIsBubbleMenuOpen(isBubbleMenuOpen: boolean) {
    this.isBubbleMenuOpen = isBubbleMenuOpen;
  }

  setSnapList(snaps: ScreenRecording[]) {
    this.snapList = snaps;
  }

  setUniversalSearchData(universalSearchData: UniversalSearchData) {
    this.universalSearchData = universalSearchData;
  }

  setAuthLoading(authLoading: boolean) {
    this.authLoading = authLoading;
  }

  //set is plan upgrade model open
  setIsPlanUpgradeModelOpen(isPlanUpgradeModelOpen: boolean) {
    this.isPlanUpgradeModelOpen = isPlanUpgradeModelOpen;
  }

  setIsTabBarLoad(isTabBarLoad: boolean) {
    this.isTabBarLoad = isTabBarLoad;
  }

  //Clear app related data
  clearAppData() {
    this.snapList = [];
    this.universalSearchData = null;
    this.screenRecordingUrl = '';
    this.isPageScrolled = false;
    this.isPlanUpgradeModelOpen = false;
  }
}
